import {useRouter} from "@tanstack/react-router";

export function useUpdateSearchParams<RootSearch>() {
  const router = useRouter();

  return (updates: Partial<RootSearch>) => {
    router.navigate({
      replace: true,
      search: ((prev: RootSearch) => {
        const next = { ...prev, ...updates };
        Object.keys(next).forEach((key) => {
          const typedKey = key as keyof RootSearch;
          if (next[typedKey] === null || next[typedKey] === undefined || next[typedKey] === '') {
            delete next[typedKey];
          }
        });
        return next;
      }) as any,
    });
  };
}